import { render, staticRenderFns } from "./NotificationVisitCard.vue?vue&type=template&id=0d3babc6&"
import script from "./NotificationVisitCard.vue?vue&type=script&lang=js&"
export * from "./NotificationVisitCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports